import { ThemedComponentProps } from '../theme.types'
import { Breakpoint, Breakpoints } from './breakpoints.types'

/** Returns breakpoint by name */
export function getBreakpoint(current: Breakpoint, breakpoints: Breakpoints): number {
  const curValue = breakpoints[current]

  if (curValue) {
    return curValue
  }
  throw new Error(`Breakpoint '${current}' not defined`)
}

/** Returns next to given breakpoint */
function getNextBreakpoint(current: Breakpoint, breakpoints: Breakpoints): number {
  const curValue = getBreakpoint(current, breakpoints)
  const values = Object.values(breakpoints).sort((a, b) => a - b)
  const curPosition = values.indexOf(curValue)
  const nextValue = values[curPosition + 1]

  if (nextValue) {
    return nextValue
  }
  throw new Error(`Next breakpoint to '${current}' not defined`)
}
function createBreakpointEnding(name: Breakpoint, breakpoints: Breakpoints): string {
  const prev = getBreakpoint(name, breakpoints)

  return `max-width: ${prev}px`
}
function createBreakpointStarting(name: Breakpoint, breakpoints: Breakpoints): string {
  const current = getBreakpoint(name, breakpoints)

  return `min-width: ${current}px`
}
function createBreakpointOnly(name: Breakpoint, breakpoints: Breakpoints): string {
  const current = getBreakpoint(name, breakpoints)
  const next = getNextBreakpoint(name, breakpoints)

  return `min-width: ${current}px and max-width: ${next}px`
}

export const breakpointEnding = (name: Breakpoint) => (props: ThemedComponentProps) => createBreakpointEnding(name, props.theme.breakpoints)

export const breakpointStarting = (name: Breakpoint) => (props: ThemedComponentProps) => createBreakpointStarting(name, props.theme.breakpoints)

export const breakpointOnly = (name: Breakpoint) => (props: ThemedComponentProps) => createBreakpointOnly(name, props.theme.breakpoints)
